import React from 'react';
import { Button as AntdButton } from 'antd';
import type { ButtonProps as AntdButtonProps } from 'antd';

export interface ButtonProps {
  variant?: 'primary' | 'default' | 'dashed' | 'text' | 'link';
  fullWidth?: boolean;
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  htmlType?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  children?: React.ReactNode;
  size?: 'small' | 'middle' | 'large';
  danger?: boolean;
  ghost?: boolean;
  shape?: 'default' | 'circle' | 'round';
  icon?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  fullWidth = false,
  isLoading = false,
  leftIcon,
  rightIcon,
  htmlType = 'button',
  className = '',
  disabled = false,
  onClick,
  children,
  size = 'middle',
  danger = false,
  ghost = false,
  shape = 'default',
  icon,
}) => {
  return (
    <AntdButton
      type={variant as AntdButtonProps['type']}
      block={fullWidth}
      loading={isLoading}
      icon={leftIcon || icon}
      htmlType={htmlType}
      className={className}
      disabled={disabled}
      onClick={onClick}
      size={size}
      danger={danger}
      ghost={ghost}
      shape={shape}
    >
      {children}
      {rightIcon && !isLoading && <span className="ml-2">{rightIcon}</span>}
    </AntdButton>
  );
};

export default Button;
